function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Children, cloneElement, createRef, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { safeSelect, wait } from '@sie/web-common-utils';
import classNames from '../utils/classNames';
import Link from '../Link';
import RotatingPanel from './RotatingPanel';
import ToastMessage from './ToastMessage';
import StringWithLink from '../StringWithLink';
/**
 * @typedef {Object} Toast
 * @property {String} type the type of toast (e.g. "success", "error")
 * @property {String|Array<String>} message The message to display. Passing a gensen
 *  translation key will be translated provided the format function is implemented.
 *  Use an array to pass additional values to be interpolated into the final string
 * @property {Number} duration minimum time to display a message. If waitFor
 *  is provided and takes longer the message will be shown for the amount of time
 *  it takes to resolve waitFor
 * @property {Promise} waitFor Async operation to wait for before dismissing the toast.
 */

/**
 * Renders a message over an existing component which will rotate in when
 * triggered
 *
 * ## Usage
 * ```jsx
 * <InlineToast
 *    target="my-inline-toast"
 *    format={format}
 *    onToast={(cb) => {}}
 * >
 *    <Button onClick={doSomethingAndEmitToast}>
 *      Do Something
 *    </Button>
 * </InlineToast>
 * ```
 *
 * ## Props
 */

var InlineToast = /*#__PURE__*/function (_PureComponent) {
  _inherits(InlineToast, _PureComponent);

  var _super = _createSuper(InlineToast);

  /**
   * Iterations keeps track of how many times the rotor has turned. This is because
   * the animation is asymmetrical  and requires the angles be adjusted accordingly
   */

  /**
   * The angle of the element containing the message + cta
   */

  /**
   * The angle of the message relative to the rotor angle
   */

  /**
   * The angle of the cta relative to the rotor angle
   */

  /**
   * Total number of notifications queued up for display one by one
   */

  /**
   * Promise indicating when to show the next notification
   */
  function InlineToast(props) {
    var _this;

    _classCallCheck(this, InlineToast);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "iterations", -1);

    _defineProperty(_assertThisInitialized(_this), "rotorAngle", 0);

    _defineProperty(_assertThisInitialized(_this), "slot2Angle", 90);

    _defineProperty(_assertThisInitialized(_this), "slot1Angle", 0);

    _defineProperty(_assertThisInitialized(_this), "toastCount", 0);

    _defineProperty(_assertThisInitialized(_this), "afterAllPreviousNotifications", Promise.resolve());

    _defineProperty(_assertThisInitialized(_this), "state", {
      /**
       * A slot is active only after it's been rotated into view
       */
      activeSlot: 1,

      /**
       * A slot is shown immediately so the rotate animation includes
       * the content within the slot
       */
      showSlot: 1,

      /**
       * render function for slot 1
       */
      slot1: null,

      /**
       * render function for slot 2
       */
      slot2: null,

      /**
       * Whether the element has been marked for removal and is animating out of view
       */
      shouldRemove: false,

      /**
       * The element is done animating and should no longer be visible or interactable
       */
      isRemoved: false
    });

    _this.container = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(InlineToast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          target = _this$props.target,
          messageDuration = _this$props.messageDuration,
          onToast = _this$props.onToast,
          removeAfterSuccess = _this$props.removeAfterSuccess;
      this.off = onToast(function (toast) {
        if (target !== toast.target) return;
        _this2.toastCount += 1;
        _this2.succeeded = _this2.succeeded || toast.type === 'success';
        _this2.afterAllPreviousNotifications = _this2.afterAllPreviousNotifications.then(function () {
          _this2.toastCount -= 1;

          if (_this2.successShown || toast.type === 'error' && _this2.succeeded) {
            return Promise.resolve();
          }

          _this2.show(toast);

          if (removeAfterSuccess && toast.type === 'success') {
            _this2.successShown = true;
          }

          return Promise.all([wait({
            for: toast.duration || messageDuration
          }).start(), toast.waitFor && toast.waitFor.catch(function () {})]);
        }).then(function () {
          if (_this2.toastCount > 0) return;

          if (removeAfterSuccess && _this2.succeeded) {
            _this2.remove();
          } else {
            _this2.show(null);
          }
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof this.off === 'function') {
        this.off();
      }

      clearTimeout(this.removalTimeout);
      clearTimeout(this.moveSlot2Timeout);
    }
  }, {
    key: "getContainerDepth",
    value: function getContainerDepth() {
      return safeSelect(this.container, 'current.clientHeight') / 2;
    }
    /**
     * Orchestrates the animation of toasts
     * @param {Toast} toast
     */

  }, {
    key: "show",
    value: function show(toast) {
      var activeSlot = this.state.activeSlot;
      var isSlot1Active = activeSlot === 1;
      var ui = this.renderSlot(toast);

      if (isSlot1Active) {
        this.iterations += 1;

        this._revealSlot2(ui);
      } else {
        this._revealSlot1(ui);
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      var _this3 = this;

      var removalAnimationDuration = this.props.removalAnimationDuration;
      this.setState({
        shouldRemove: true
      });
      this.removalTimeout = setTimeout(function () {
        _this3.setState({
          isRemoved: true
        });
      }, removalAnimationDuration);
    }
  }, {
    key: "_revealSlot2",
    value: function _revealSlot2(ui) {
      this.rotorAngle = -90 + this.iterations * -180;

      this._moveSlot1AfterTransition();

      this.setState({
        showSlot: 2,
        slot2: ui
      });
    }
    /**
     * We need to delay the moving the component to prevent
     * the movement being visible to the user
     */

  }, {
    key: "_moveDelay",
    value: function _moveDelay() {
      var animationDuration = this.props.animationDuration;
      return animationDuration + 100;
    }
  }, {
    key: "_moveSlot1AfterTransition",
    value: function _moveSlot1AfterTransition() {
      var _this4 = this;

      setTimeout(function () {
        _this4.slot1Angle = -180 + _this4.iterations * -180;

        _this4.setState({
          activeSlot: 2
        });
      }, this._moveDelay());
    }
  }, {
    key: "_revealSlot1",
    value: function _revealSlot1(ui) {
      this.rotorAngle = -180 + this.iterations * -180;

      this._moveSlot2AfterTransition();

      this.setState({
        showSlot: 1,
        slot1: ui
      });
    }
  }, {
    key: "_moveSlot2AfterTransition",
    value: function _moveSlot2AfterTransition() {
      var _this5 = this;

      this.moveSlot2Timeout = setTimeout(function () {
        _this5.slot2Angle = -90 + _this5.iterations * -180;

        _this5.setState({
          activeSlot: 1
        });
      }, this._moveDelay());
    }
  }, {
    key: "_getHeight",
    value: function _getHeight() {
      if (!this.container.current) return null;
      var shouldRemove = this.state.shouldRemove;
      if (shouldRemove) return 0;
      return this.container.current.getBoundingClientRect().height;
    }
  }, {
    key: "renderSlot",
    value: function renderSlot(toast) {
      var _this6 = this;

      if (toast === null) {
        return function () {
          var children = _this6.props.children;
          return children;
        };
      }

      return function (_ref) {
        var shouldShow = _ref.shouldShow;
        var format = _this6.props.format;
        var messageParts = Array.isArray(toast.message) ? toast.message : [toast.message];
        return /*#__PURE__*/React.createElement(ToastMessage, {
          className: "psw-fill",
          format: format,
          shouldShow: shouldShow,
          iconType: toast.type === 'error' ? 'error-message-caution' : 'check',
          message: /*#__PURE__*/React.createElement(StringWithLink, {
            src: format.apply(void 0, ['string'].concat(_toConsumableArray(messageParts)))
          }, (toast.links || []).map(function (x) {
            return /*#__PURE__*/React.createElement(Link, x, format('string', x.label));
          }))
        });
      };
    }
  }, {
    key: "renderSpacer",
    value: function renderSpacer() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          qa = _this$props2.qa;
      return /*#__PURE__*/React.createElement("div", {
        "aria-hidden": true,
        "data-qa": "".concat(qa, "#cta-spacer"),
        className: "psw-l-line-left psw-hidden"
      }, Children.toArray(children).map(function (el) {
        return /*#__PURE__*/cloneElement(el, {
          qa: "".concat(qa, "#hiddenCta")
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          qa = _this$props3.qa,
          animationDuration = _this$props3.animationDuration,
          removalAnimationDuration = _this$props3.removalAnimationDuration,
          children = _this$props3.children,
          ariaLive = _this$props3.ariaLive;
      var _this$state = this.state,
          slot1 = _this$state.slot1,
          slot2 = _this$state.slot2,
          activeSlot = _this$state.activeSlot,
          showSlot = _this$state.showSlot,
          shouldRemove = _this$state.shouldRemove,
          isRemoved = _this$state.isRemoved;
      var depth = this.getContainerDepth();
      return /*#__PURE__*/React.createElement("div", {
        ref: this.container,
        style: {
          perspective: 2000,
          height: this._getHeight(),
          transition: "height ".concat(removalAnimationDuration, "ms ease, opacity ").concat(removalAnimationDuration, "ms ease"),
          opacity: shouldRemove ? '0' : null,
          overflow: shouldRemove ? 'hidden' : null,
          visibility: isRemoved ? 'hidden' : null
        },
        className: classNames(className, 'psw-l-anchor'),
        "aria-hidden": isRemoved,
        "data-qa": qa
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          // transform-origin does not work properly in Safari
          // https://bugs.webkit.org/show_bug.cgi?id=88587
          // the work around is to introduce another div as a context for the rotation
          transform: "translateZ(-".concat(depth, "px)"),
          transformStyle: 'preserve-3d'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          transition: "transform ".concat(animationDuration, "ms ease-in"),
          transformStyle: 'preserve-3d',
          transform: "rotateX(".concat(this.rotorAngle, "deg)")
        }
      }, this.renderSpacer(), /*#__PURE__*/React.createElement(RotatingPanel, {
        qa: "".concat(qa, "#slot2"),
        animationDuration: animationDuration,
        angle: this.slot2Angle,
        shouldShow: showSlot === 2,
        depth: depth,
        ariaLive: ariaLive
      }, typeof slot2 === 'function' && slot2({
        shouldShow: activeSlot === 2
      })), /*#__PURE__*/React.createElement(RotatingPanel, {
        qa: "".concat(qa, "#slot1"),
        animationDuration: animationDuration,
        angle: this.slot1Angle,
        shouldShow: showSlot === 1,
        depth: depth,
        ariaLive: ariaLive
      }, typeof slot1 === 'function' && slot1({
        shouldShow: activeSlot === 1
      }) || children))));
    }
  }]);

  return InlineToast;
}(PureComponent);

InlineToast.defaultProps = {
  qa: 'inline-toast',
  className: '',
  target: '',
  animationDuration: 300,
  removalAnimationDuration: 400,
  messageDuration: 4000,
  ariaLive: 'assertive',
  removeAfterSuccess: false,
  children: null,
  onToast: function onToast() {},
  format: function format() {}
};
InlineToast.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin
   */
  className: PropTypes.string,

  /**
   * Must be a unique string to identify the specific inline toast as multplie
   * inline toasts can exist on a page.
   */
  target: PropTypes.string,

  /**
   * How long the rotation animation runs for
   */
  animationDuration: PropTypes.number,

  /**
   * The default duration for how long the message is displayed for
   */
  messageDuration: PropTypes.number,

  /**
   * The politeness setting for our toast live region
   */
  ariaLive: PropTypes.oneOf(['assertive', 'polite']),

  /**
   * Remove the toast and associated item visually after the success toast message is
   * shown
   */
  removeAfterSuccess: PropTypes.bool,

  /**
   * The duration of the removal animation
   */
  removalAnimationDuration: PropTypes.number,

  /**
   * The UI to show
   */
  children: PropTypes.node,

  /**
   * Method for registering when toast notifications are emitted and should
   * be displayed. onToast receives a callback which should be called whenever
   * a toast needs to be displayed. The emitted toast object must have a target
   * which matches the inline toast component instance. It must also have a
   * message field.
   */
  onToast: PropTypes.func,

  /**
   * Web common I18n format function
   */
  format: PropTypes.func
};
export default InlineToast;